import React from 'react';

export const getConditionalComponent = (
	condition: boolean,
	component: (args: any) => React.JSX.Element,
) => {
	if (condition) {
		return component;
	}
	return ({ children }: { children: React.ReactNode }) => <>{children}</>;
};
